// CalendarDataContext.js
import { createContext } from 'react';

const CalendarDataContext = createContext([]);

export default CalendarDataContext;